<template>
  <div class="nav" :v-loading="loading">
    <div class="main-bg">
      <div class="nav-head">
        <div class="nav-left">
          <!-- <div class="search">
            <div class="search-input">
              <el-input class="sinput" v-model="searchKey" @keyup.enter.native="onSearch" placeholder="搜索"></el-input>
              <el-button type="plain" @click="onSearch">搜索</el-button>
            </div>
          </div> -->
          <div class="title-log" @click="onHomeClick">
            <div class="title-bg"></div>
          </div>
        </div>
        <div class="nav-right">
          <div class="search">
            <div class="search-input">
              <el-input class="sinput" v-model="searchKey" @keyup.enter.native="onSearch" placeholder="搜索"></el-input>
              <!-- <el-button type="plain" @click="onSearch">搜索</el-button> -->
            </div>
          </div>
          <template v-if="!loginUser">
            <div class="button" @click="onRegistClick">注册</div>
            <div class="button-re" @click="onLoginClick">登录</div>
          </template>
          <template v-if="loginUser">
            <div class="button">
              <a href="myInfo.html" target="_blank" class="myHover">欢迎您：{{ loginUser.chnName }}</a>
            </div>
            <div class="button">
              <a href="myPost.html" target="_blank" class="myHover">我的稿件</a>
            </div>
            <div class="button" v-if="canUpPic" @click="onUploadPic">上传稿件</div>
            <div class="button" v-if="canUpVideo" @click="onUploadVideo">上传视频</div>
            <div class="button" @click="onLogoutClick">退出</div>
          </template>
        </div>
      </div>
    </div>
    <div class="whole">
      <div class="nav-main">
        <div class="nav-list" v-if="navList">
          <div class="nav-detail" v-for="(k, kindex) in navList" :key="k + 'nav_' + kindex" :class="{ active: navIndex == kindex }">
            <a v-if="k.dis" @click="onUserMore">{{ k.name }}</a>
            <a v-else :href="k.url">{{ k.name }}</a>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="用户登录" :visible.sync="loginDialogShow" width="40vw" class="login-dialog">
      <div class="login-content">
        <div class="name"><span>用户名</span><el-input v-model="loginName" placeholder="请输入用户名"></el-input></div>
        <div class="pwd"><span>密码：</span><el-input v-model="loginPassword" placeholder="请输入密码" show-password></el-input></div>
        <div class="code">
          <span>验证码：</span>
          <el-input v-model="icode" placeholder="请输入验证码" clearable></el-input>
          <img :src="icodeURL" alt="" class="yan-img" @click="onRefreshCodeImg" />
        </div>
        <el-button class="backMsg" @click="onForgetpswd">找回密码</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="loginDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="onLoginConfirmClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// @ is an alias to /src
import RD from '@/api/RD'
import sha1 from 'js-sha1'

export default {
  name: 'Nav',
  components: {},
  props: {
    navIndex: {
      type: Number,
      default: function () {
        return 0
      },
    },
  },

  data: function () {
    return {
      loginName: '', // 登录名
      loginPassword: '', // 密码
      icode: '', // 验证码
      searchKey: '', // 搜索的条件
      loginUser: undefined, // 是否登录的状态
      loginDialogShow: false, // 登录框的显示
      canUpPic: false, // 是否可以上传稿件
      canUpVideo: false, // 是否可以上传稿件
      icodeURL: '', // 验证码的图片路径
      loading: false, // 加载的loading效果
      navActiveIndex: 0, // 高亮的nav
      navList: [
        { name: '网站首页', url: '/index.html' },
        {
          name: '今日读图',
          url: '/fixTopic.html?id=52',
        },
        {
          name: '视频专区',
          url: '/fixTopic.html?id=53',
        },
        {
          name: '地方图库',
          url: '/localCity.html',
        },
        {
          name: '活动公告',
          url: '/notice.html',
        },
        {
          name: '上传稿件',
          url: '/upPost.html',
        },
        {
          name: '我的图库',
          url: '/myPost.html',
        },
        {
          name: '返回主站',
          url: 'https://www.chinaphotos.cn/',
        },
      ],
    }
  },
  created() {
    var thiz = this
    this.init()
  },
  mounted() {
    var thiz = this
    this.init()
  },
  methods: {
    onNavClick(nav) {
      this.$router.push(nav.url)
    },
    // sync刷新
    init() {
      var thiz = this
      RD.pure()
        .user()
        .sync()
        .then((data) => {
          thiz.loginUser = data
          if (data.approveStatus == 'APPROVED' && data.upPicStores.length != 0) {
            thiz.canUpPic = true
          }
          if (data.approveStatus == 'APPROVED' && data.upVideoStores.length != 0) {
            thiz.canUpVideo = true
          }
          if (data.approveStatus == 'APPROVED') {
            thiz.checkVoterOptions()
          }
        })
        .catch(() => {})
    },
    // 登录
    onLoginClick() {
      this.loginDialogShow = true
      this.onRefreshCodeImg()
    },
    // 检查是否有可以评选的活动
    checkVoterOptions() {
      var thiz = this
      RD.activityTopic()
        .checkVoter()
        .then((data) => {
          if (data.length != 0) {
            thiz.activityTopicSelectShow = true
          }
          thiz.activitySelectList = data
        })
    },
    onRefreshCodeImg() {
      this.icodeURL = RD.user().icodeImage_URL() + '?' + new Date().getTime()
    },
    // 回到首页
    onHomeClick() {
      let routerUrl = this.$router.resolve({
        path: '/index.html',
      })
      window.open(routerUrl.href, '_blank')
    },
    onRegistClick() {
      this.$alert('请到主站网址注册', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        callback: (action) => {
          window.open('https://www.chinaphotos.cn/')
        },
      })
    },
    onLoginConfirmClick() {
      var thiz = this
      thiz.loading = true
      if (thiz.logoName == '') {
        thiz.$rtm.message.notify('用户名不能为空')
        return
      }
      if (thiz.passWord == '') {
        thiz.$rtm.message.notify('密码不能为空')
        return
      }
      if (thiz.icode) {
        RD.pure()
          .user()
          .login(thiz.icode, thiz.loginName, sha1(thiz.loginPassword))
          .then(() => {
            location.reload()
          })
          .catch((error) => {
            thiz.onRefreshCodeImg()
            thiz.$rtm.message.notify(error.msg)
            thiz.icode = ''
            thiz.loading = false
          })
      } else {
        thiz.$rtm.message.notify('请输入验证码再登录')
      }
    },
    onLogoutClick() {
      // var thiz = this;
      RD.user()
        .logout()
        .then(() => {
          location.reload()
        })
    },
    // 搜索
    onSearch() {
      var thiz = this
      let routerUrl = this.$router.resolve({
        path: '/search.html',
        query: { keyword: thiz.searchKey },
      })
      window.open(routerUrl.href, '_blank')
    },
    // 找回密码
    onForgetpswd() {
      let routerUrl = this.$router.resolve({
        path: '/forgetPassWord.html',
      })
      window.open(routerUrl.href, '_blank')
    },
    // 上传图片
    onUploadPic() {
      if (this.loginUser) {
        let routerUrl = this.$router.resolve({
          path: '/upPost.html',
        })
        window.open(routerUrl.href, '_blank')
      } else {
        this.$message('请先登录账户再上传')
      }
    },
    // 上传视频
    onUploadVideo() {
      if (this.loginUser) {
        let routerUrl = this.$router.resolve({
          path: '/uploadVideo.html',
        })
        window.open(routerUrl.href, '_blank')
      } else {
        this.$message('请先登录账户再上传')
      }
    },
  },
}
</script>
<style lang="less" scoped>
.main-bg {
  background-color: #b7916c;
}

.login-dialog {
  .login-content {
    text-align: left;
    margin-left: 12%;
    .name,
    .pwd,
    .code {
      margin-bottom: 0.8rem;
      line-height: 4rem;
      span {
        width: 7.5rem;
        display: inline-block;
      }
      .el-input {
        width: 25rem;
      }
    }
    .backMsg {
      position: absolute;
      left: 5rem;
      bottom: 2rem;
      padding: 1rem;
    }
    .code {
      display: flex;
      flex-wrap: nowrap;
      .code-img {
        width: 10rem;
        height: 4.2rem;
      }
      .yan-img {
        margin-left: 0.5rem;
      }
    }
  }
  .el-button {
    height: 4rem;
  }
}
.othernav {
  height: 10rem !important;
  width: 100% !important;
}
.duck {
  background: rgba(0, 0, 0, 0.85) !important;
  transition: 500ms all ease-in-out;
}

.wx {
  height: 43rem;
  width: 40rem;
  margin: 0 auto;
  font-size: 1.5rem;
  .wx-img {
    width: 100%;
    height: 100%;
  }
}
.red-nav-button {
  color: red;
}

.red-nav-button:hover {
  background-color: red;
  color: white;
}

@media all and (min-width: 801px) {
  .nav {
    height: auto;
    width: 100%;
    .main-bg {
      height: 12rem;
    }
    .nav-head {
      display: flex;
      height: 100%;
      position: relative;
      width: 1200px;
      max-width: 95vw;
      margin: 0 auto;
      display: flex;
      .nav-left {
        height: 11rem;
        width: 40rem;
        .title-log {
          width: 100%;
          height: 100%;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          .title-bg {
            height: 93%;
            width: 97%;
            background: no-repeat 50% / contain url(../assets/logo.png);
          }
        }
      }
      .nav-right {
        flex: 1;
        width: 800px;
        height: 100%;
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap;
        align-items: center;
        .search {
          height: 100%;
          margin-right: 2rem;
          .search-input {
            width: 250px;
            height: 100%;
            border-radius: 12px;
            position: relative;
            display: flex;
            align-items: center;
            .sinput {
              height: 60px;
              line-height: 60px;
              ::v-deep.el-input__inner {
                border-radius: 10px;
                width: 250px;
                background-color: #fff;
              }
            }
            .el-button {
              height: 40px;
              margin-left: 10px;
              font-size: 16px;
            }
          }
        }
        .button {
          cursor: pointer;
          padding: 0px 10px;
          height: 25px;
          line-height: 25px;
          color: #000;
          text-align: center;
          font-size: 15px;
          margin-right: 10px;
        }
        .button-re {
          border-left: 1px solid #000;
          cursor: pointer;
          padding: 0px 10px;
          height: 25px;
          line-height: 25px;
          color: #000;
          text-align: center;
          font-size: 15px;
          margin-right: 10px;
          padding-left: 2rem;
        }
      }
    }
    .nav-main {
      width: 1200px;
      max-width: 95vw;
      margin: 0px auto;
      display: flex;

      .nav-list {
        flex: 1;
        display: flex;
        height: 75px;
        gap: 0px;
        flex-wrap: wrap;
        justify-content: space-between;
        .nav-detail {
          transition: all 200ms ease-in-out;
          font-size: 18px;
          cursor: pointer;
          position: relative;
          text-align: center;
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .nav-detail:hover,
        .nav-detail.active:hover {
          font-size: 22px;
          color: #fff;
          background: #ff8c00;
        }
        .nav-detail.active {
          color: white;
          font-size: 22px;
          background: #f9a957;
        }
      }
    }
    .el-button {
      height: 4rem;
      font-size: 1.2rem;
    }
  }
}

@media all and (max-width: 800px) {
  .nav {
    width: 750px;
    .main-bg {
      height: auto;
      width: 100%;
      .nav-head {
        display: flex;
        height: 60px;
        position: relative;
        width: 750px;
        margin: 0 auto;
        display: flex;
        position: relative;
        .nav-left {
          height: 60px;
          width: 335px;
          .search {
            height: 100%;
            .search-input {
              width: 250px;
              height: 100%;
              border-radius: 12px;
              position: relative;
              display: flex;
              align-items: center;
              .sinput {
                height: 60px;
                line-height: 60px;
                ::v-deep.el-input__inner {
                  border-radius: 10px;
                  width: 250px;
                  background-color: #fff;
                }
              }
              .el-button {
                height: 40px;
                margin-left: 10px;
                font-size: 16px;
              }
            }
          }
        }
        .nav-right {
          width: 410px;
          height: 60px;
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
          align-items: center;
          .button {
            cursor: pointer;
            padding: 0px 10px;
            height: 25px;
            line-height: 25px;
            color: #000;
            background-color: #fff;
            text-align: center;
            font-size: 15px;
            border-radius: 3px;
            margin-right: 10px;
          }
        }
      }
      .el-button {
        height: 2rem;
        font-size: 1.2rem;
      }
    }
    .whole {
      width: 750px;
      .nav-main {
        width: 750px;
        margin: 0px auto;
        display: flex;
        .title-log {
          width: 100px;
          height: 78px;
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          .title-bg {
            height: 80%;
            width: 80%;
            background: no-repeat 50% / contain url(../assets/logo.png);
          }
        }
        .nav-list {
          flex: 1;
          display: flex;
          height: 75px;
          gap: 0px;
          flex-wrap: wrap;
          justify-content: space-between;
          .nav-detail {
            transition: all 200ms ease-in-out;
            font-size: 18px;
            cursor: pointer;
            position: relative;
            text-align: center;
            flex: 1;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .nav-detail:hover,
          .nav-detail.active:hover {
            font-size: 22px;
            color: #fff;
            background: #ff8c00;
          }
          .nav-detail.active {
            color: white;
            font-size: 22px;
            background: #007cc8;
          }
        }
      }
    }
  }
}
</style>
